import axios, { rawAxios } from '@/lib/axios'
import { buildAdminRequestConfig, type OrganizationId } from '@/lib/organization-scoping'
import type { ReportQueryKeyEntries } from '@/lib/services/reports/reports.api'
import type { QueryFunctionContext } from '@tanstack/react-query'
import type { BookedSalesFilters } from './money.schema'
import type { BookedSalesReport } from './money.types'

/** What the export and print requests take. */
export interface BookedSalesRequest {
  organizationId: OrganizationId
  filters: BookedSalesFilters
}

export function getBookedSales({
  queryKey: [{ organizationId, filters }],
}: Pick<QueryFunctionContext<[ReportQueryKeyEntries<BookedSalesFilters>]>, 'queryKey'>) {
  return axios.get<BookedSalesReport>(
    '/reports/booked-sales',
    buildAdminRequestConfig({ organizationId, params: { ...filters } })
  )
}
export function exportBookedSales({ organizationId, filters }: BookedSalesRequest) {
  return rawAxios.get<Blob>(
    '/reports/booked-sales/export',
    buildAdminRequestConfig({ organizationId, params: { ...filters }, responseType: 'blob' })
  )
}
export function printBookedSales({ organizationId, filters }: BookedSalesRequest) {
  return axios.get<string>(
    '/reports/booked-sales/print',
    buildAdminRequestConfig({ organizationId, params: { ...filters }, responseType: 'text' })
  )
}
